import styled from 'styled-components'
import React, { ReactNode } from 'react'
import { colors } from '../../../assets/colors'
import { isDesktop } from '../../../constants'

const Header = styled.div`
  flex-shrink: 0;
  height: 40px;
  width: 100%;
  background-color: ${isDesktop ? colors.white : colors.silver};
  color: ${colors.mediumGrey};
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 5px;
  cursor: pointer;
`

export default Header
